module.exports = __webpack_public_path__ + "static/amazon-1e7149f7737d85c102d9bc52caa8bcee.png";